import { Product } from '../__product'

export const getUTMSource = (masthead: string) => {
    switch (masthead) {
        case Product.SevenNews:
            return '7NEWS'
        case Product.PerthNow:
            return 'PerthNow'
        case Product.TheWest:
            return 'TheWest'
        case Product.TheNightly:
            return 'TheNightly'
        default:
            return ''
    }
}

export const applyTrackingParameters = (
    url: string,
    masthead: string,
): string => {
    if (url.includes('view.com.au')) {
        const urlObject = new URL(url)
        const utmSource = getUTMSource(masthead)
        if (utmSource && !urlObject.searchParams.get('utm_source')) {
            urlObject.searchParams.set('utm_source', utmSource)
        }

        return urlObject.toString()
    }
    return url
}
